// extracted by mini-css-extract-plugin
export var body = "bm_c";
export var buttons = "bm_cr";
export var container = "bm_b";
export var icon = "bm_bq";
export var icons = "bm_bw";
export var image = "bm_g";
export var items = "bm_fF";
export var label = "bm_cl";
export var mobileButtons = "bm_fG";
export var name = "bm_fD";
export var section = "bm_d";
export var selected = "bm_bg";
export var show = "bm_L";
export var title = "bm_h";